
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/auth';
import { createProspect, updateProspectDetails, deleteProspect } from '@/hooks/pipeline/operations/modify-prospects';
import { Prospect } from '@/types/pipeline';
import { ContactData } from '../types';

export const useProspectApi = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const createProspectMutation = useMutation({
    mutationFn: (prospectData: Omit<Prospect, 'id' | 'created_at' | 'updated_at'>) => 
      createProspect({
        ...prospectData,
        user_id: user?.id || ''
      } as any),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prospects'] });
      queryClient.invalidateQueries({ queryKey: ['pipeline-data'] });
    },
  });

  const updateProspectMutation = useMutation({
    mutationFn: ({ prospectId, updates }: { prospectId: string; updates: Partial<Prospect> }) =>
      updateProspectDetails(prospectId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prospects'] });
      queryClient.invalidateQueries({ queryKey: ['pipeline-data'] });
    },
  });

  const deleteProspectMutation = useMutation({
    mutationFn: (prospectId: string) => deleteProspect(prospectId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['prospects'] });
      queryClient.invalidateQueries({ queryKey: ['pipeline-data'] });
    },
  });

  return {
    createProspect: createProspectMutation,
    updateProspect: updateProspectMutation,
    deleteProspect: deleteProspectMutation,
    addContact: async (data: ContactData) => {
      console.warn('Attempted to use decommissioned feature: addContact', data);
      return { error: new Error('This functionality is currently disabled.') };
    },
    currentWorkspaceId: '',
  };
};
